module.exports = __webpack_public_path__ + "static/media/SFProDisplay-Regular.d09549c1.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SFPro/TrueType/SFProDisplay-Regular.ttf
// module id = 2540
// module chunks = 7